import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const use404RedirectIf = (shouldRedirect: boolean) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldRedirect) {
      navigate('/404', { replace: true });
    }
  }, [shouldRedirect, navigate]);
};
